import { AppVariantConfig } from '@/types/app-config';

export const crmsVariant: AppVariantConfig = {
  id: 'crms',
  name: 'CRM',
  description: 'Customer relationship management focused',
  defaultRoute: 'directory',
  appModules: {
    directory: { enabled: true },
    portal: { 
      enabled: true, 
      requiresFeature: 'portal',
      subModules: {
        mail: { enabled: true, requiresFeature: 'mail' },
        addressBook: { enabled: true, requiresFeature: 'address_book' }
      }
    },
    archive: { enabled: true, requiresFeature: 'archive' }
  },
  adminModules: {
    users: { enabled: true },
    mail: { enabled: true },
    address_book: { enabled: true },
    analytics: { enabled: true },
    settings: { enabled: true },
    design: { enabled: true },
    onboarding: { enabled: true }
  }
}; 